const translation = {
  currentPlan: 'Obecny plan',
  upgradeBtn: {
    plain: 'Ulepsz plan',
    encourage: 'Ulepsz teraz',
    encourageShort: 'Ulepsz',
  },
  viewBilling: 'Zarządzaj rozliczeniami i subskrypcjami',
  buyPermissionDeniedTip:
    'Skontaktuj się z administratorem swojej firmy, aby zasubskrybować',
  plansCommon: {
    title: 'Wybierz plan odpowiedni dla siebie',
    yearlyTip: 'Otrzymaj 2 miesiące za darmo, subskrybując rocznie!',
    mostPopular: 'Najpopularniejszy',
    planRange: {
      monthly: 'Miesięczny',
      yearly: 'Roczny',
    },
    month: 'miesiąc',
    year: 'rok',
    save: 'Oszczędź ',
    free: 'Darmowy',
    currentPlan: 'Obecny plan',
    contractSales: 'Skontaktuj się z działem sprzedaży',
    contractOwner: 'Skontaktuj się z zarządcą zespołu',
    startForFree: 'Zacznij za darmo',
    getStartedWith: 'Rozpocznij z ',
    contactSales: 'Kontakt z działem sprzedaży',
    talkToSales: 'Porozmawiaj z działem sprzedaży',
    modelProviders: 'Dostawcy modeli',
    teamMembers: 'Członkowie zespołu',
    buildApps: 'Twórz aplikacje',
    vectorSpace: 'Przestrzeń wektorowa',
    vectorSpaceBillingTooltip:
      'Każdy 1MB może przechowywać około 1,2 miliona znaków z wektoryzowanych danych (szacowane na podstawie OpenAI Embeddings, różni się w zależności od modelu).',
    vectorSpaceTooltip:
      'Przestrzeń wektorowa jest systemem pamięci długoterminowej wymaganym dla LLM, aby zrozumieć Twoje dane.',
    documentsUploadQuota: 'Limit przesyłanych dokumentów',
    documentProcessingPriority: 'Priorytet przetwarzania dokumentów',
    documentProcessingPriorityTip:
      'Dla wyższego priorytetu przetwarzania dokumentów, ulepsz swój plan.',
    documentProcessingPriorityUpgrade:
      'Przetwarzaj więcej danych z większą dokładnością i w szybszym tempie.',
    priority: {
      'standard': 'Standardowy',
      'priority': 'Priorytetowy',
      'top-priority': 'Najwyższy priorytet',
    },
    logsHistory: 'Historia logów',
    customTools: 'Niestandardowe narzędzia',
    unavailable: 'Niedostępne',
    days: 'dni',
    unlimited: 'Nieograniczony',
    support: 'Wsparcie',
    supportItems: {
      communityForums: 'Forum społecznościowe',
      emailSupport: 'Wsparcie mailowe',
      priorityEmail: 'Priorytetowa pomoc mailowa i czat',
      logoChange: 'Zmiana logo',
      SSOAuthentication: 'Uwierzytelnianie SSO',
      personalizedSupport: 'Personalizowane wsparcie',
      dedicatedAPISupport: 'Dedykowane wsparcie API',
      customIntegration: 'Niestandardowa integracja i wsparcie',
      ragAPIRequest: 'Żądania API RAG',
      bulkUpload: 'Masowe przesyłanie dokumentów',
      agentMode: 'Tryb agenta',
      workflow: 'Przepływ pracy',
      llmLoadingBalancing: 'Równoważenie obciążenia LLM',
      llmLoadingBalancingTooltip: 'Dodaj wiele kluczy API do modeli, skutecznie omijając limity szybkości interfejsu API.',
    },
    comingSoon: 'Wkrótce dostępne',
    member: 'Członek',
    memberAfter: 'Członek',
    messageRequest: {
      title: 'Limity kredytów wiadomości',
      tooltip:
        'Limity wywołań wiadomości dla różnych planów używających modeli OpenAI (z wyjątkiem gpt4). Wiadomości przekraczające limit będą korzystać z twojego klucza API OpenAI.',
      titlePerMonth: '{{count,number}} wiadomości/miesiąc',
    },
    annotatedResponse: {
      title: 'Limity kredytów na adnotacje',
      tooltip:
        'Ręczna edycja i adnotacja odpowiedzi zapewniają możliwość dostosowania wysokiej jakości odpowiedzi na pytania dla aplikacji. (Stosowane tylko w aplikacjach czatowych)',
    },
    ragAPIRequestTooltip:
      'Odnosi się do liczby wywołań API wykorzystujących tylko zdolności przetwarzania bazy wiedzy Dify.',
    receiptInfo:
      'Tylko właściciel zespołu i administrator zespołu mogą subskrybować i przeglądać informacje o rozliczeniach',
    annotationQuota: 'Przydział adnotacji',
    documents: '{{count,number}} Dokumentów Wiedzy',
    apiRateLimit: 'Limit liczby wywołań API',
    documentsTooltip: 'Kwota dotycząca liczby dokumentów importowanych z Źródła Danych Wiedzy.',
    unlimitedApiRate: 'Brak limitu liczby zapytań API',
    annualBilling: 'Roczne rozliczenie',
    getStarted: 'Zacznij',
    freeTrialTip: 'bezpłatny okres próbny 200 wywołań OpenAI.',
    comparePlanAndFeatures: 'Porównaj plany i funkcje',
    freeTrialTipPrefix: 'Zarejestruj się i zdobądź',
    teamMember_other: '{{count,number}} członków zespołu',
    teamWorkspace: '{{count,number}} Zespół Workspace',
    apiRateLimitUnit: '{{count,number}}/dzień',
    cloud: 'Usługa chmurowa',
    teamMember_one: '{{count,number}} Członek zespołu',
    priceTip: 'na przestrzeń roboczą/',
    self: 'Samo-hostowane',
    apiRateLimitTooltip: 'Limit aktywności API dotyczy wszystkich żądań składanych za pośrednictwem API Dify, w tym generowania tekstu, rozmów czatowych, wykonywania przepływów pracy i przetwarzania dokumentów.',
    freeTrialTipSuffix: 'Nie jest wymagana karta kredytowa',
    documentsRequestQuota: '{{count,number}}/min Limit wiedzy na żądanie',
    documentsRequestQuotaTooltip: 'Określa całkowitą liczbę działań, jakie przestrzeń robocza może wykonać na minutę w ramach bazy wiedzy, w tym tworzenie zbiorów danych, usuwanie, aktualizacje, przesyłanie dokumentów, modyfikacje, archiwizowanie i zapytania do bazy wiedzy. Ta metryka jest używana do oceny wydajności zapytań do bazy wiedzy. Na przykład, jeśli użytkownik Sandbox wykona 10 kolejnych testów w ciągu jednej minuty, jego przestrzeń robocza zostanie tymczasowo ograniczona w wykonywaniu następujących działań przez następną minutę: tworzenie zbiorów danych, usuwanie, aktualizacje oraz przesyłanie lub modyfikacje dokumentów.',
  },
  plans: {
    sandbox: {
      name: 'Sandbox',
      description: '200 razy darmowa próba GPT',
      includesTitle: 'Zawiera:',
      for: 'Darmowy okres próbny podstawowych funkcji',
    },
    professional: {
      name: 'Profesjonalny',
      description:
        'Dla osób fizycznych i małych zespołów, aby odblokować więcej mocy w przystępnej cenie.',
      includesTitle: 'Wszystko w darmowym planie, plus:',
      for: 'Dla niezależnych deweloperów/małych zespołów',
    },
    team: {
      name: 'Zespół',
      description:
        'Współpracuj bez ograniczeń i ciesz się najwyższą wydajnością.',
      includesTitle: 'Wszystko w planie Profesjonalnym, plus:',
      for: 'Dla średniej wielkości zespołów',
    },
    enterprise: {
      name: 'Przedsiębiorstwo',
      description:
        'Uzyskaj pełne możliwości i wsparcie dla systemów o kluczowym znaczeniu dla misji.',
      includesTitle: 'Wszystko w planie Zespołowym, plus:',
      features: {
        3: 'Wiele przestrzeni roboczych i zarządzanie przedsiębiorstwem',
        5: 'Wynegocjowane SLA przez Dify Partners',
        0: 'Rozwiązania do wdrożeń na dużą skalę klasy przedsiębiorstw',
        8: 'Profesjonalne wsparcie techniczne',
        2: 'Ekskluzywne funkcje przedsiębiorstwa',
        6: 'Zaawansowane zabezpieczenia i kontrola',
        7: 'Aktualizacje i konserwacja przez Dify Oficjalnie',
        4: 'SSO',
        1: 'Autoryzacja licencji komercyjnej',
      },
      priceTip: 'Tylko roczne fakturowanie',
      btnText: 'Skontaktuj się z działem sprzedaży',
      for: 'Dla dużych zespołów',
      price: 'Niestety, nie mogę przetłumaczyć tego tekstu bez konkretnego zdania do przetłumaczenia.',
    },
    community: {
      features: {
        0: 'Wszystkie funkcje podstawowe wydane w publicznym repozytorium',
        1: 'Jedno Miejsce Pracy',
        2: 'Zgodne z licencją Dify Open Source',
      },
      includesTitle: 'Darmowe funkcje:',
      name: 'Społeczność',
      price: 'Darmowy',
      description: 'Dla użytkowników indywidualnych, małych zespołów lub projektów niekomercyjnych',
      btnText: 'Rozpocznij pracę z społecznością',
      for: 'Dla użytkowników indywidualnych, małych zespołów lub projektów niekomercyjnych',
    },
    premium: {
      features: {
        0: 'Samozarządzana niezawodność różnych dostawców chmury',
        1: 'Jedno miejsce pracy',
        3: 'Priorytetowe wsparcie przez e-mail i czat',
        2: 'Logo aplikacji internetowej i dostosowanie marki',
      },
      description: 'Dla średnich organizacji i zespołów',
      for: 'Dla średnich organizacji i zespołów',
      name: 'Premium',
      priceTip: 'Oparte na rynku chmurowym',
      btnText: 'Uzyskaj premium w',
      price: 'Skalowalny',
      comingSoon: 'Wsparcie dla Microsoft Azure i Google Cloud wkrótce dostępne',
      includesTitle: 'Wszystko z Community, plus:',
    },
  },
  vectorSpace: {
    fullTip: 'Przestrzeń wektorowa jest pełna.',
    fullSolution: 'Ulepsz swój plan, aby uzyskać więcej miejsca.',
  },
  apps: {
    fullTipLine1: 'Ulepsz swój plan, aby',
    fullTipLine2: 'tworzyć więcej aplikacji.',
    fullTip1des: 'Osiągnąłeś limit tworzenia aplikacji w tym planie.',
    fullTip1: 'Zaktualizuj, aby stworzyć więcej aplikacji',
    fullTip2: 'Osiągnięto limit planu',
    contactUs: 'Skontaktuj się z nami',
    fullTip2des: 'Zaleca się usunięcie nieaktywnych aplikacji, aby zwolnić miejsce, lub skontaktowanie się z nami.',
  },
  annotatedResponse: {
    fullTipLine1: 'Ulepsz swój plan, aby',
    fullTipLine2: 'adnotować więcej rozmów.',
    quotaTitle: 'Limit adnotacji odpowiedzi',
  },
  usagePage: {
    vectorSpace: 'Magazynowanie danych wiedzy',
    teamMembers: 'Członkowie zespołu',
    documentsUploadQuota: 'Limit przesyłania dokumentów',
    buildApps: 'Twórz aplikacje',
    annotationQuota: 'Kwota aneksji',
    vectorSpaceTooltip: 'Dokumenty z trybem indeksowania o wysokiej jakości będą zużywać zasoby magazynu danych wiedzy. Gdy magazyn danych wiedzy osiągnie limit, nowe dokumenty nie będą przesyłane.',
  },
  teamMembers: 'Członkowie zespołu',
}

export default translation
